import { render, staticRenderFns } from "./NewNegotiation.vue?vue&type=template&id=67845570"
import script from "./NewNegotiation.vue?vue&type=script&lang=js"
export * from "./NewNegotiation.vue?vue&type=script&lang=js"
import style0 from "./NewNegotiation.vue?vue&type=style&index=0&id=67845570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports